import { InjectionToken } from '@angular/core';

export const DebugFlagList: InjectionToken<DebugFlag[]> = new InjectionToken<DebugFlag[]>(
  'DebugFlagList'
);
export const DevelopmentModuleProdEnvironment: InjectionToken<boolean> = new InjectionToken<
  boolean
>('DevelopmentModuleProdEnvironment');

export interface DebugFlag {
  name: string;
  hasMetadata?: boolean;
  metadataHint?: string;
  inputType?: string;
  onChange?: (enabled: boolean, metadata?: string) => void;
}

export interface DebugFlagSettings {
  [flagName: string]: boolean | any;
}

export const GlobalDebugFlags: DebugFlag[] = [];
